import React from 'react';

class ProductsPageMain extends React.Component {
  render() {
  	return (
        <section className="section bg-light" id="network">
            <div className="container">
                <div className="row vertical-content">
                    <div className="col-lg-12">
                        <div className="features-box">
                            
                            
                            <p className=" web-desc">The products of IvyNet have a common goal.   To help people.  In order to help people we must shore up and support the businesses that also help people. Each of our products provides for, covers the gap, by reducing it, and mitigates loss and risk for companies who currently are exposed..</p>
                        
                        
                        </div>
                    </div>
                    {/* <div className="col-lg-7">
                        <div className="features-img features-right text-right">
                            <img src="images/online-world.svg" alt="macbook image" className="img-fluid" />
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
  	);
  }
}
export default ProductsPageMain;